export default "__VITE_ASSET__8b9feafb__"